import { Directive, Input, OnInit, ElementRef, Renderer2 } from '@angular/core';
import { AppAbstractDirective } from './appAbstractDirective';

@Directive({
  selector: '[appFullContent]'
})
export class AppFullContentDirective extends AppAbstractDirective implements OnInit {

  @Input() parentLevel: number;

  constructor(
    private element: ElementRef,
    private renderer: Renderer2
  ) {
    super();
  }

  ngOnInit(): void {
    this.renderer.addClass( this.element.nativeElement, 'fullContent');
    if (this.parentLevel !== undefined && this.parentLevel !== null) {
      let elementAux = this.element.nativeElement;
      for (let i = 1; i <= this.parentLevel; i++) {
        elementAux = elementAux.parentElement;
        if (elementAux !== undefined && elementAux !== null) {
          if (elementAux.classList.contains('card-body') || elementAux.classList.contains('card')) {
            this.renderer.addClass( elementAux, 'fullContentCard');
          } else {
            this.renderer.addClass( elementAux, 'fullContent');
          }
        } else {
          break;
        }
      }
    }
  }

}
